import {
	GET_MEMBERSHIPS_SUCCESS,
	ADD_ADMIN_MEMBERSHIP,
	DELETE_ADMIN_MEMBERSHIP,
	UPDATE_ADMIN_MEMBERSHIP,
	GET_MEMBERSHIP_HISTORY,
	GET_MEMBERSHIP_NOTES,
	ADD_MEMBERSHIP_NOTES
} from '../../Actions/Admin/ManageMembershipActions';

const initialState = {
	allMemberships: [],
	membershipHistory:[],
	membershipNotes:[]
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_MEMBERSHIPS_SUCCESS:
			return {
				...state,
				loading: true,
				allMemberships: action.payload
			};
		case ADD_ADMIN_MEMBERSHIP:
		return {
			...state,
			allMemberships: action.payload
		};
	   case DELETE_ADMIN_MEMBERSHIP:
		return {
			...state,
			allMemberships: action.payload
		};
		case UPDATE_ADMIN_MEMBERSHIP:
		return {
			...state,
			allMemberships: action.payload
		};
		case GET_MEMBERSHIP_HISTORY:
		return {
			...state,
			membershipHistory: action.payload
		};
		case GET_MEMBERSHIP_NOTES:
		return {
			...state,
			membershipNotes: action.payload
		};
		case ADD_MEMBERSHIP_NOTES:
			return {
				...state,
				membershipNotes: action.payload
			};
		default:
			return state;
	}
};
